/* eslint-disable */

/**
 * Dependencies:
 * - Custom select component
 *
 * Required translation strings:
 * - addToCart
 * - noStock
 * - noVariant
 * - onlyXLeft
 */

if (!customElements.get("variant-picker")) {
	class VariantPicker extends HTMLElement {
		constructor() {
			super();
			this.section = this.closest(".js-product");
			this.productForm = this.section.querySelector(
				".js-product-form-main"
			);
			this.optionSelectors = this.querySelectorAll(".option-selector");
			this.data = this.getProductData();
			this.variant = this.getSelectedVariant();

			this.updateAvailability();
			this.updateAddToCartButton();
			this.addEventListener(
				"change",
				this.handleVariantChange.bind(this)
			);
			this.updateDiscountPercentage();

			this.secondaryVariantPickerInit();

		}

		secondaryVariantPickerInit() {
			const secondaryVariantSelectedValue = document.querySelector('.sticky-atc-panel .bpn-custom-select .selected-value');
			const secondaryVariantIdField = document.querySelector('.sticky-atc-panel input[name="id"][type="hidden"]');

			if (!secondaryVariantIdField) {return}
			
			this.addEventListener('change', () => {
			  secondaryVariantIdField.value = this.getSelectedVariant().id;
			  secondaryVariantSelectedValue.textContent = this.getSelectedVariant().title;
			});

			secondaryVariantIdField.addEventListener('change', (event) => {
			  this.updateMainPicker(secondaryVariantIdField.getAttribute('value'), event);
			});
		  }

		 updateMainPicker(variantId) {
			const variant = this.data.product.variants.find(v => v.id.toString() === variantId);
			if (!variant) return;
		 
			this.optionSelectors.forEach((selector, index) => {
			  if (selector.dataset.selectorType === "dropdown") {
				 const button = selector.querySelector(".custom-select__btn");
				 button.textContent = variant.options[index];
				 button.dispatchEvent(new Event('change', { bubbles: true }));
			  } else {
				 const input = selector.querySelector(`input[value="${variant.options[index]}"]`);
				 if (input) {
					input.checked = true;
					input.dispatchEvent(new Event('change', { bubbles: true }));
				 }
			  }
			});
		 
			// Trigger the variant change handling
			this.handleVariantChange();
		 }

		/**
		 * Handles 'change' events on the variant picker element.
		 * @param {object} evt - Event object.
		 */
		handleVariantChange(evt) {
			this.variant = null;

			// Get selected variant data (if variant exists).
			this.variant = this.getSelectedVariant();

			if (this.variant) {
				this.updateMedia();
				if (evt) {
					this.updateUrl(evt);
				}
				this.updateVariantInput();
			}

			this.updateAddToCartButton();
			this.updateAvailability();
			this.updatePrice();
			this.updateWeight();
			this.updateBarcode();
			this.updateBackorderText();
			this.updatePickupAvailability();
			this.updateSku();
			if (evt) {
				VariantPicker.updateLabelText(evt);
			}

			this.dispatchEvent(
				new CustomEvent("on:variant:change", {
					bubbles: true,
					detail: {
						form: this.productForm,
						variant: this.variant,
						product: this.data.product,
					},
				})
			);

			this.updateDiscountPercentage();
		}

		/**
		 * Updates the discount percentage.
		 */
		updateDiscountPercentage() {
			// Select all elements with the class ".product-option__discount-percentage"
			this.discountPercentages =
				this.discountPercentages ||
				this.section.querySelectorAll(
					".product-option__discount-percentage"
				);
			if (this.discountPercentages.length === 0) return;

			// Iterate over each selected element
			this.discountPercentages.forEach((discountPercentageElement) => {
				// Get the option associated with this element from the data-option attribute on the element
				const option =
					discountPercentageElement.getAttribute("data-option");
				if (!option) return;

				var variant = this.data.product.variants.find((v) => {
					return (
						v.options.some((optionValue, index) => {
							// Check if the option matches for all except the current one
							if (
								this.variant.options[index] === optionValue &&
								this.data.product.options[index].name !== option
							) {
								return true;
							}
							return false;
						}) && v.options.includes(option)
					);
				});

				if (this.variant.options.includes(option)) {
					variant = this.variant;
				}

				if (!variant) return;
				// Calculate the discount percentage
				const discountPercentage =
					variant && variant.compare_at_price > variant.price
						? (
								((variant.compare_at_price - variant.price) /
									variant.compare_at_price) *
								100
						  ).toFixed(0)
						: 0;

				// Update the content with the calculated discount percentage
				discountPercentageElement.textContent =
					discountPercentage > 0 ? `${discountPercentage}% OFF` : "";
			});
		}
		/**
		 * Updates the "Add to Cart" button label and disabled state.
		 */
		updateAddToCartButton() {
			this.productForm = this.section.querySelector(
				".js-product-form-main"
			);
			if (!this.productForm) return;

			this.addBtn =
				this.addBtn || this.productForm.querySelector('[name="add"]');
			const variantAvailable = this.variant && this.variant.available;
			const unavailableStr = this.variant
				? theme.strings.noStock
				: theme.strings.noVariant;

			this.addBtn.disabled = !variantAvailable;
			this.addBtn.textContent = variantAvailable
				? this.addBtn.dataset.addToCartText
				: unavailableStr;
		}

		/**
		 * Updates the availability status of an option.
		 * @param {Element} optionEl - Option element.
		 * @param {boolean} exists - Does this option lead to a variant that exists?
		 * @param {boolean} available - Does this option lead to a variant that is available to buy?
		 */
		static updateOptionAvailability(optionEl, exists, available) {
			const el = optionEl;
			const unavailableText = exists
				? theme.strings.noStock
				: theme.strings.noVariant;
			el.classList.toggle("is-unavailable", !available);
			el.classList.toggle("is-nonexistent", !exists);

			if (optionEl.classList.contains("custom-select__option")) {
				const em = el.querySelector("em");

				if (em) {
					em.hidden = available;
				}

				if (!available) {
					if (em) {
						em.textContent = unavailableText;
					} else {
						el.innerHTML = `${el.innerHTML} <em class="pointer-events-none">${unavailableText}</em>`;
					}
				}
			} else if (!available) {
				el.nextElementSibling.title = unavailableText;
			} else {
				el.nextElementSibling.removeAttribute("title");
			}
		}

		/**
		 * Updates the availability status in option selectors.
		 */
		updateAvailability() {
			if (this.dataset.showAvailability === "false") return;
			const { availabilityMethod } = this.dataset; // 'downward' or 'selection'
			let currVariant = this.variant;
			const selectedOptions = this.getSelectedOptions();

			if (!this.variant) {
				currVariant = { options: selectedOptions };
			}

			if (availabilityMethod === "selection") {
				// Flag all options as unavailable
				this.querySelectorAll(".js-option").forEach((optionEl) => {
					VariantPicker.updateOptionAvailability(
						optionEl,
						false,
						false
					);
				});

				// Flag selector options as available or sold out, depending on the variant availability
				this.optionSelectors.forEach((selector, selectorIndex) => {
					this.data.product.variants.forEach((variant) => {
						let matchCount = 0;

						variant.options.forEach((option, optionIndex) => {
							if (
								option === currVariant.options[optionIndex] &&
								optionIndex !== selectorIndex
							) {
								matchCount += 1;
							}
						});

						if (matchCount === currVariant.options.length - 1) {
							const options =
								selector.querySelectorAll(".js-option");
							const optionEl = Array.from(options).find((opt) => {
								if (
									selector.dataset.selectorType === "dropdown"
								) {
									return (
										opt.dataset.value ===
										variant.options[selectorIndex]
									);
								}
								return (
									opt.value === variant.options[selectorIndex]
								);
							});

							if (optionEl) {
								VariantPicker.updateOptionAvailability(
									optionEl,
									true,
									variant.available
								);
							}
						}
					});
				});
			} else {
				this.optionSelectors.forEach((selector, selectorIndex) => {
					const options = selector.querySelectorAll(
						'.js-option:not([data-value=""])'
					);
					options.forEach((option) => {
						const optionValue =
							selector.dataset.selectorType === "dropdown"
								? option.dataset.value
								: option.value;
						// any available variants with previous options and this one locked in?
						let variantsExist = false;
						let variantsAvailable = false;
						this.data.product.variants.forEach((v) => {
							let matches = 0;
							for (let i = 0; i < selectorIndex; i += 1) {
								if (
									v.options[i] === selectedOptions[i] ||
									selectedOptions[i] === null
								) {
									matches += 1;
								}
							}
							if (
								v.options[selectorIndex] === optionValue &&
								matches === selectorIndex
							) {
								variantsExist = true;
								if (v.available) {
									variantsAvailable = true;
								}
							}
						});
						VariantPicker.updateOptionAvailability(
							option,
							variantsExist,
							variantsAvailable
						);
					});
				});
			}
		}

		/**
		 * Updates the backorder text and visibility.
		 */
		updateBackorderText() {
			this.backorder =
				this.backorder || this.section.querySelector(".backorder");
			if (!this.backorder) return;

			let hideBackorder = true;

			if (this.variant && this.variant.available) {
				const { inventory } = this.data.formatted[this.variant.id];

				if (this.variant.inventory_management && inventory === "none") {
					const backorderProdEl = this.backorder.querySelector(
						".backorder__product"
					);
					const prodTitleEl =
						this.section.querySelector(".product-title");
					const variantTitle = this.variant.title.includes("Default")
						? ""
						: ` - ${this.variant.title}`;

					backorderProdEl.textContent = `${prodTitleEl.textContent}${variantTitle}`;
					hideBackorder = false;
				}
			}

			this.backorder.hidden = hideBackorder;
		}

		/**
		 * Updates the color option label text.
		 * @param {object} evt - Event object
		 */
		static updateLabelText(evt) {
			const selector = evt.target.closest(".option-selector");
			if (selector.dataset.selectorType === "dropdown") return;

			const colorText = selector.querySelector(".js-color-text");
			if (!colorText) return;

			colorText.textContent =
				evt.target.nextElementSibling.querySelector(
					".js-value"
				).textContent;
		}

		/**
		 * Updates the product media.
		 */
		updateMedia() {
			if (!this.variant.featured_media) return;

			if (this.section.matches("quick-add-drawer")) {
				this.section.updateMedia(this.variant.featured_media.id);
			} else {
				this.mediaGallery =
					this.mediaGallery ||
					this.section.querySelector("media-gallery");
				if (!this.mediaGallery) return;

				const variantMedia = this.mediaGallery.querySelector(
					`[data-media-id="${this.variant.featured_media.id}"]`
				);
				this.mediaGallery.setActiveMedia(variantMedia, true, true);
			}
		}

		/**
		 * Updates the pick up availability.
		 */
		updatePickupAvailability() {
			this.pickUpAvailability =
				this.pickUpAvailability ||
				this.section.querySelector("pickup-availability");
			if (!this.pickUpAvailability) return;

			if (this.variant && this.variant.available) {
				this.pickUpAvailability.getAvailability(this.variant.id);
			} else {
				this.pickUpAvailability.removeAttribute("available");
				this.pickUpAvailability.innerHTML = "";
			}
		}

		/**
		 * Updates the price.
		 */
		// updatePriceOld() {
		// 	this.price =
		// 		this.price ||
		// 		this.section.querySelector(".product-info__price > .price");
		// 	if (!this.price) return;

		// 	if (this.variant) {
		// 		const priceCurrentEl =
		// 			this.price.querySelector(".price__current");
		// 		const priceWasEl = this.price.querySelector(".price__was");
		// 		const unitPriceEl = this.price.querySelector(".unit-price");

		// 		// Update current price and original price if on sale.
		// 		priceCurrentEl.innerHTML =
		// 			this.data.formatted[this.variant.id].price;
		// 		if (priceWasEl)
		// 			priceWasEl.innerHTML =
		// 				this.data.formatted[this.variant.id].compareAtPrice ||
		// 				"";

		// 		// Update unit price, if specified.
		// 		if (this.variant.unit_price_measurement) {
		// 			const valueEl =
		// 				this.price.querySelector(".unit-price__price");
		// 			const unitEl =
		// 				this.price.querySelector(".unit-price__unit");
		// 			const value =
		// 				this.variant.unit_price_measurement.reference_value;
		// 			const unit =
		// 				this.variant.unit_price_measurement.reference_unit;

		// 			valueEl.innerHTML =
		// 				this.data.formatted[this.variant.id].unitPrice;
		// 			unitEl.textContent =
		// 				value === 1 ? unit : `${value} ${unit}`;
		// 		}

		// 		unitPriceEl.hidden = !this.variant.unit_price_measurement;
		// 		this.price.classList.toggle(
		// 			"price--on-sale",
		// 			this.variant.compare_at_price > this.variant.price
		// 		);
		// 		this.price.classList.toggle(
		// 			"price--sold-out",
		// 			!this.variant.available
		// 		);
		// 	}

		// 	this.price.querySelector(".price__default").hidden = !this.variant;
		// 	this.price.querySelector(".price__no-variant").hidden =
		// 		this.variant;
		// }
		updatePrice() {
			this.prices = this.prices || document.querySelectorAll(".product-info__price > .price, .sticky-atc-panel .top-inner-wrap > .price");
			if (!this.prices.length) return;
	  
			this.prices.forEach(price => {
				 if (this.variant) {
					  const priceCurrentEl = price.querySelector(".price__current");
					  const priceWasEl = price.querySelector(".price__was");
					  const unitPriceEl = price.querySelector(".unit-price");
	  
					  // Update current price and original price if on sale.
					  if (priceCurrentEl) {
							priceCurrentEl.innerHTML = this.data.formatted[this.variant.id].price;
					  }
					  if (priceWasEl) {
							priceWasEl.innerHTML = this.data.formatted[this.variant.id].compareAtPrice || "";
					  }

					  // Trade view: keep "Retail $x" and "$y under retail" in sync.
					  // this.variant.price is raw retail cents; checkout discount is
					  // exactly 33.33%, so mirror price - round(price * 0.3333).
					  const tradeRetailEl = price.querySelector(".nnm-trade-retail");
					  const tradeUnderEl = price.querySelector(".nnm-trade-under");
					  if (tradeRetailEl || tradeUnderEl) {
							const nnmFmt = (c) => "$" + (c / 100).toFixed(2);
							const nnmRetail = this.variant.price;
							const nnmDisc = Math.round(nnmRetail * 0.3333);
							if (tradeRetailEl) tradeRetailEl.textContent = "Retail " + nnmFmt(nnmRetail);
							if (tradeUnderEl) tradeUnderEl.textContent = nnmFmt(nnmDisc) + " under retail";
					  }
	  
					  // Update unit price, if specified.
					  if (this.variant.unit_price_measurement && unitPriceEl) {
							const valueEl = price.querySelector(".unit-price__price");
							const unitEl = price.querySelector(".unit-price__unit");
							const value = this.variant.unit_price_measurement.reference_value;
							const unit = this.variant.unit_price_measurement.reference_unit;
	  
							if (valueEl) {
								 valueEl.innerHTML = this.data.formatted[this.variant.id].unitPrice;
							}
							if (unitEl) {
								 unitEl.textContent = value === 1 ? unit : `${value} ${unit}`;
							}
	  
							unitPriceEl.hidden = false;
					  } else if (unitPriceEl) {
							unitPriceEl.hidden = true;
					  }
	  
					  price.classList.toggle(
							"price--on-sale",
							this.variant.compare_at_price > this.variant.price
					  );
					  price.classList.toggle(
							"price--sold-out",
							!this.variant.available
					  );
				 }
	  
				 const defaultPriceEl = price.querySelector(".price__default");
				 const noVariantPriceEl = price.querySelector(".price__no-variant");
	  
				 if (defaultPriceEl) {
					  defaultPriceEl.hidden = !this.variant;
				 }
				 if (noVariantPriceEl) {
					  noVariantPriceEl.hidden = this.variant;
				 }
			});
	  }

		/**
		 * Updates the weight.
		 */
		updateWeight() {
			this.weights =
				this.weights ||
				this.section.querySelectorAll(".product-info__weight");
			if (this.weights.length === 0) return;

			const weightAvailable = this.variant && this.variant.weight > 0;
			this.weights.forEach((weight) => {
				weight.textContent = weightAvailable
					? this.data.formatted[this.variant.id].weight
					: "";
				weight.hidden = !weightAvailable;
			});
		}

		/**
		 * Updates the Barcode.
		 */
		updateBarcode() {
			this.barcodes =
				this.barcodes ||
				this.section.querySelectorAll(".product-info__barcode-value");
			if (this.barcodes.length === 0) return;

			const barcodeAvailable = this.variant && this.variant.barcode;
			this.barcodes.forEach((barcode) => {
				barcode.textContent = barcodeAvailable
					? this.variant.barcode
					: "";
				barcode.parentNode.hidden = !barcodeAvailable;
			});
		}

		/**
		 * Updates the SKU.
		 */
		updateSku() {
			this.sku =
				this.sku || this.section.querySelector(".product-sku__value");
			if (!this.sku) return;

			const skuAvailable = this.variant && this.variant.sku;
			this.sku.textContent = skuAvailable ? this.variant.sku : "";
			this.sku.parentNode.hidden = !skuAvailable;
		}

		/**
		 * Updates the url with the selected variant id.
		 * @param {object} evt - Event object.
		 */
		updateUrl(evt) {
			if (
				!evt ||
				evt.type !== "change" ||
				this.dataset.updateUrl === "false"
			)
				return;
			window.history.replaceState(
				{},
				"",
				`${this.dataset.url}?variant=${this.variant.id}`
			);
		}

		/**
		 * Updates the value of the hidden [name="id"] form inputs.
		 */
		updateVariantInput() {
			this.forms =
				this.forms ||
				this.section.querySelectorAll(
					".js-product-form-main, .js-product-form-secondary,.js-instalments-form"
				);

			this.forms.forEach((form) => {
				const input = form.querySelector('input[name="id"]');
				input.value = this.variant.id;
				input.dispatchEvent(new Event("change", { bubbles: true }));
			});
		}

		/**
		 * Gets the selected option element from each selector.
		 * @returns {Array}
		 */
		getSelectedOptions() {
			const selectedOptions = [];

			this.optionSelectors.forEach((selector) => {
				if (selector.dataset.selectorType === "dropdown") {
					selectedOptions.push(
						selector
							.querySelector(".custom-select__btn")
							.textContent.trim()
					);
				} else {
					selectedOptions.push(
						selector.querySelector("input:checked").value
					);
				}
			});

			return selectedOptions;
		}

		/**
		 * Gets the product data.
		 * @returns {?object}
		 */
		getProductData() {
			const dataEl = this.querySelector('[type="application/json"]');
			return JSON.parse(dataEl.textContent);
		}

		/**
		 * Get selected variant data.
		 * @returns {?object} Variant object, or null if one is not selected.
		 */
		getSelectedVariant() {
			const selectedOptions = this.getSelectedOptions();
			return this.data.product.variants.find((v) =>
				v.options.every((val, index) => val === selectedOptions[index])
			);
		}
	}

	customElements.define("variant-picker", VariantPicker);
}
